<template>
    <div>
        <div class="d-flex justify-content-between align-items-center">
            <div>
                <b class="me-3">页面作品</b>
            </div>
            <div class="text-end">
                <router-link class="el-button el-button--primary el-button--small" to="/h5maker/home">新建页面</router-link>
            </div>
        
        </div>
        <hr>
        <div class="py-2">
            <ul class="nav nav-primary border-bottom">
                <li class="nav-item">
                    <router-link class="nav-link" :to="{ name: $route.name }">全部</router-link>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link" :to="{ name: $route.name, query: { is_published: 1 } }">已发布</router-link>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link" :to="{ name: $route.name, query: { is_published: 0 } }">未发布</router-link>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link" :to="{ name: $route.name, query: { status: 1 } }">回收站</router-link>
                </li>
            </ul>
        </div>
        <!-- <div v-if="$route.query.status==1">
            <div class="text-end">
                <button class="btn btn-sm" @click="clearTrash"> <i class="bi bi-trash3"></i> 清空回收站 </button>
            </div>
        </div> -->
        <div class="mt-3">
            <list-group :list="list" :show-add-btn="false" v-on:handelChange="onListGroupChange"></list-group>
        </div>
        <div class="page text-center p-3 mt-4" v-if="list && page.total > 10">
            <el-pagination background layout="total, prev, pager, next, jumper" :total="page.total" :page-size="page.pageSize"
                :current-page="page.currentPage" @current-change="onPageChange"></el-pagination>
        </div>
    </div>
</template>

<script>
import api from './api'
import ListGroup from './component/ListGroup.vue'

class Page {
    total = 0
    pageSize = 12
    currentPage = 1
}

export default {
    components: { ListGroup },
    data() {
        return {
            list: null,
            page: new Page()
        }
    },
    created() {
        this.getList()
    },
    methods: {
        async getList() {
            const query = this.$route.query

            const res = await api.fetchList({ size: this.page.pageSize, page: this.page.currentPage, ...query })
            this.list = res && res.data ? res.data.results : []

            this.page.total = res.data.count

        },
        // 重置列表
        resetList() {
            this.list = null
            this.page = new Page()
            this.getList()
        },
        onPageChange(e) {
            this.page.currentPage = e
            this.getList()
        },
        onListGroupChange() {
            this.getList()
        },
        clearTrash() {
            // TODO
        }
    },
    watch: {
        '$route.query': {
            handler(n, o) {
                this.resetList()
            },
            immediate: true
        }
    }
}
</script>
